var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"mx-width":"1000px","height":"300px"},attrs:{"id":"echart1"}})}
var staticRenderFns = []

export { render, staticRenderFns }